import { InspectionItemKind, TireSeason, type InspectionItemRecord } from '@navio/nsdk';

export type WheelSetGroup = {
  key: string;
  season: TireSeason;
  carWheelSetId: number | null;
  items: InspectionItemRecord[];
};

const SEASON_RANK: Record<TireSeason, number> = {
  [TireSeason.SUMMER]: 0,
  [TireSeason.WINTER]: 1,
  [TireSeason.ALL_SEASON]: 2
};

/** Wheel sets in season order. A skipped row stays with the unseasoned list. */
export const groupWheelSets = (items: InspectionItemRecord[]): WheelSetGroup[] => {
  const groups = new Map<string, WheelSetGroup>();
  for (const item of items) {
    const season = item.tire?.season;
    if (!season || item.kind === InspectionItemKind.SKIP) {
      continue;
    }
    const carWheelSetId = item.tire?.carWheelSetId ?? null;
    const key = `${carWheelSetId ?? 'none'}:${season}`;
    const existing = groups.get(key);
    if (existing) {
      existing.items.push(item);
    } else {
      groups.set(key, { key, season, carWheelSetId, items: [item] });
    }
  }
  return [...groups.values()].sort(
    (left, right) =>
      SEASON_RANK[left.season] - SEASON_RANK[right.season] || (left.carWheelSetId ?? 0) - (right.carWheelSetId ?? 0)
  );
};
